import React, { Component } from "react";
import { constants } from "../../Constants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Spring } from "react-spring";
import Swal from "sweetalert2";
import { validationEmail } from "../../helpers/response";
import moment from 'moment';
import {
  CounsellorsActions,
  alertActions,
  WhitelabelActions,
  LanguagesActions,
  AppointmentActions,
  PatientActions,
} from "../../store/actions";
import { history } from "../../helpers";
import Loading from "../../components/Loading/Loading";
import HeaderComponent from "../../components/Header";
import Footer from "../../components/Footer/footer";
import "../../static/css/styles.css";
import Select from "react-select";
import { languages } from "../../store/reducers/languages.reducer";
import { white } from "material-ui/colors";

const selectStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px ",
    color: state.isSelected ? "black" : "",
    fontSize: 16,
    backgroundColor: state.isSelected ? "#eee" : "",
    textAlign: "left",
    cursor: "pointer"
  }),
  container: base => ({
    ...base,
    width: "auto"
  }),
  control: base => ({
    ...base,
    height: 41,
    fontSize: 15,
    borderRadius: "4px",
    width: "100%",
    textAlign: "left",
    cursor: "pointer"
  }),
  valueContainer: base => ({
    ...base,
    padding: 0,
    paddingLeft: 2
  })
};

const optionsMonths = [
  { value: '0', label: 'January' },
  { value: '1', label: 'February' },
  { value: '2', label: 'March' },
  { value: '3', label: 'April' },
  { value: '4', label: 'May' },
  { value: '5', label: 'June' },
  { value: '6', label: 'July' },
  { value: '7', label: 'August' },
  { value: '8', label: 'September' },
  { value: '9', label: 'October' },
  { value: '10', label: 'November' },
  { value: '11', label: 'December' },
]

const optionsYears = [
  { value: '2021', label: '2021' },
  { value: '2022', label: '2022' },
  { value: '2023', label: '2023' },
  { value: '2024', label: '2024' },
  { value: '2025', label: '2025' },
  { value: '2020', label: '2026' },
]

const optionsTime = [
  { value: '00:00:00', label: '12:00 AM' },
  { value: '01:00:00', label: '1:00 AM' },
  { value: '02:00:00', label: '2:00 AM' },
  { value: '03:00:00', label: '3:00 AM' },
  { value: '04:00:00', label: '4:00 AM' },
  { value: '05:00:00', label: '5:00 AM' },
  { value: '06:00:00', label: '6:00 AM' },
  { value: '07:00:00', label: '7:00 AM' },
  { value: '08:00:00', label: '8:00 AM' },
  { value: '09:00:00', label: '9:00 AM' },
  { value: '10:00:00', label: '10:00 AM' },
  { value: '11:00:00', label: '11:00 AM' },
  { value: '12:00:00', label: '12:00 PM' },
  { value: '13:00:00', label: '1:00 PM' },
  { value: '14:00:00', label: '2:00 PM' },
  { value: '15:00:00', label: '3:00 PM' },
  { value: '16:00:00', label: '4:00 PM' },
  { value: '17:00:00', label: '5:00 PM' },
  { value: '18:00:00', label: '6:00 PM' },
  { value: '19:00:00', label: '7:00 PM' },
  { value: '20:00:00', label: '8:00 PM' },
  { value: '21:00:00', label: '9:00 PM' },
  { value: '22:00:00', label: '10:00 PM' },
  { value: '23:00:00', label: '11:00 PM' },
]

class CreateAppointment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialCounsellor: null,
      whitelabel: "",
      error_whitelabel: "",
      counsellor: "",
      error_counsellor: "",
      counsellors_list: [],
      patients: "",
      error_patient: "",
      error_date: "",
      error_time: "",
      patients_list: [],
      selected_day: "",
      selected_month: "",
      selected_year: "",
      selected_time: "",
      patientSelected: "",
      counsellorSelected: "",
      projectsSelected: "",
      days_created: [],
      timeZone: "",
      selectedId: "",
      counsellor: [],
      loading: false,
      isLoading: ""
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentWillMount() {
    this.props.fetchWhitelabel();
    this.props.fetchLanguages();
    this.props.fetchCounsellors();
    // this.props.fetchPatients();
    this.createDates();
    this.setTimeZone();
  }

  toggleLoading = (status) => {
    this.setState({ loading: status });
  };

  createDates = () => {
    const { selected_month, selected_year } = this.state;
    const maxDays = new Date(selected_year, selected_month, 0).getDate();
    let result = [];
    for (let i = 1; i <= maxDays; i++) {
      result.push({
        label: i,
        value: i
      });
    }
    this.setState({
      days_created: result
    })
    return result;
  };

  componentDidMount() {
    if (this.props.languages && this.props.languages.languages)
      this.setState({ languages: this.props.languages.languages });
    if (
      this.props.counsellors &&
      this.props.selectedCounsellor &&
      this.props.selectedCounsellor !== ""
    ) {
      //edit
      const obj = this.props.counsellors.find(
        (c) =>
          c.counsellor_details.counsellor_id === this.props.selectedCounsellor
      );
      if (obj) {
        let projectsSelected = [];
        let languagesSelected = [];
        let counsellorSelected = [];
        if (obj.project_details && obj.project_details.length > 0) {
          obj.project_details.map((p) => {
            return projectsSelected.push({ value: p.id, label: p.name });
          });

          if (this.props.languages.languages) {
            obj.counsellor_details.languages.map((p) => {
              const lang = this.props.languages.languages.filter(
                (l) => l.language === p
              )[0];
              return languagesSelected.push({
                value: lang.id,
                label: lang.language,
              });
            });
          }
        }

        this.setState({
          initialCounsellor: obj,
          selectedId: this.props.selectedCounsellor,
          name: obj.user_details.full_name,
          email: obj.user_details.email,
          phone: obj.counsellor_details.contact_number,
          qualifications: obj.counsellor_details.qualifications,
          focus: obj.counsellor_details.area_of_expertise,
          price_usd: obj.counsellor_details.price_usd,
          price_pkr: obj.counsellor_details.price_pkr,
          projectsSelected,
          languagesSelected,
          city: obj.counsellor_details.home_city,
          mode: "edit",
          loading: false,
          languages: this.props.languages.languages,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { projects, languages, counsellors_list, patients, counsellors } = this.state;
    if (!!nextProps && nextProps.languages && nextProps.languages.languages)
      this.setState({ languages: nextProps.languages.languages });

    if (!!nextProps && nextProps.whitelabel)
      if (projects !== nextProps.whitelabel) {
        this.setState({ projects: nextProps.whitelabel, loading: false });
        this.props.fetchPatients(this.state.projectsSelected.value)
      }
    if (!!nextProps && nextProps.patients) {
      if (patients !== nextProps.patients) {
        this.setState({ patients_list: nextProps.patients })
      }
    }

    if (!!nextProps && nextProps.counsellors) {
      if (counsellors !== nextProps.counsellors) {
        this.setState({ counsellors_list: nextProps.counsellors })
        const obj = nextProps.counsellors.find(
          (c) =>
            c.counsellor_details.counsellor_id === this.props.selectedCounsellor
        );

        if (obj) {
          let projectsSelected = [];
          // let languagesSelected = [];
          if (obj.project_details && obj.project_details.length > 0) {
            obj.project_details.map((p) => {
              return projectsSelected.push({ value: p.id, label: p.name });
            });
          }
          this.setState({
            initialCounsellor: obj,
            selectedId: this.props.selectedCounsellor,
            name: obj.user_details.full_name,
            email: obj.user_details.email,
            phone: obj.counsellor_details.contact_number,
            qualifications: obj.counsellor_details.qualifications,
            focus: obj.counsellor_details.area_of_expertise,
            //projects: false,
            price_usd: obj.counsellor_details.price_usd,
            price_pkr: obj.counsellor_details.price_pkr,
            projectsSelected,
            // languagesSelected: languagesSelected !== [] ? languagesSelected : this.state.languagesSelected,
            city: obj.counsellor_details.home_city,
            mode: "edit",
            loading: false,
            counsellors: nextProps.counsellors,
          });
        } else
          this.setState({ counsellors: nextProps.counsellors, loading: false });
      }
    }
  }

  setTimeZone = () => {
    const dt = new Date();
    if (dt.toString().indexOf('(') > -1) {
      const timezone = dt.toString().split('(')[1].split(')')[0];
      this.setState({ timeZone: timezone });
    }
  };

  changePatients = (patientSelected) => {
    this.setState({ error_patient: "", patientSelected })
  }

  changeCounsellors = (counsellorSelected) => {
    this.setState({ error_counsellor: "", counsellorSelected })
  }

  changeProjects = (projectsSelected) => {
    this.setState({ error_whitelabel: "", patientSelected: "", projectsSelected });
    if (projectsSelected.value.toLowerCase() !== 'counsellor') {
      this.props.fetchPatients(projectsSelected.value)
    }
  };

  changeLanguages = (languagesSelected) => {
    this.setState({ languagesSelected });
  };

  onChangeYear = (e) => {
    this.setState({ error_date: "", selected_year: e });
  };

  onChangeDay = (e) => {
    this.setState({ error_date: "", selected_day: e });
  };

  onChangeMonth = (e) => {
    this.setState({ error_date: "", selected_month: e });
  };

  onChangeUser = (e) => {
    this.setState({ selected_patient: e });
  };

  onChangeTime = (e) => {
    this.setState({ error_time: "", selected_time: e });
  };

  changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "file") {
      this.setState({ [name]: e.target.files[0] });
    } else {
      this.setState({ [name]: value });
    }
  };

  validate = () => {
    let projectFlag, counsellorFlag, patientFlag, dateFlag, timeFlag = false;
    let {
      error_whitelabel,
      error_counsellor,
      error_patient,
      error_date,
      error_time,
      selected_day,
      selected_month,
      selected_year,
      selected_time,
      patientSelected,
      counsellorSelected,
      projectsSelected,
    } = this.state;
    if (this.isEmpty(projectsSelected.value)) {
      error_whitelabel = this.isEmpty(projectsSelected.value) ? "Please enter whitelabel" : "";
      projectFlag = false;
    } else {
      projectFlag = true;
      error_whitelabel = "";
    }
    if (this.isEmpty(counsellorSelected.value)) {
      error_counsellor = this.isEmpty(counsellorSelected.value) ? "Please enter counsellor" : "";
      counsellorFlag = false;
    } else {
      counsellorFlag = true;
      error_counsellor = "";
    }
    if (this.isEmpty(patientSelected.value)) {
      error_patient = this.isEmpty(patientSelected.value) ? "Please enter patient" : "";
      patientFlag = false;
    } else {
      patientFlag = true;
      error_patient = "";
    }
    if (this.isEmpty(selected_day.value) || this.isEmpty(selected_month.value) || this.isEmpty(selected_year.value)) {
      error_date = this.isEmpty(selected_day.value) || this.isEmpty(selected_month.value) || this.isEmpty(selected_year.value) ? "Please enter date" : "";
      dateFlag = false;
    } else {
      dateFlag = true;
      error_date = "";
    }
    if (this.isEmpty(selected_time.value)) {
      error_time = this.isEmpty(selected_time.value) ? "Please enter time" : "";
      timeFlag = false;
    } else {
      timeFlag = true;
      error_time = "";
    }
    this.setState({
      error_whitelabel,
      error_counsellor,
      error_patient,
      error_date,
      error_time,
    });
    return (
      projectFlag &&
      counsellorFlag &&
      patientFlag &&
      dateFlag &&
      timeFlag
    );
    
  };

  isEmpty = (val) => {
    return val === '' || val === undefined
  }

  AdminCreateAppointment = (e) => {
    const { projectsSelected, counsellorSelected, patientSelected, selected_day, selected_month, selected_year, selected_time } = this.state;
    if (this.validate()) {
      const current_time = moment(new Date()).utc().format();
      const date = `${parseInt(selected_year.value)}-${parseInt(selected_month.value) + 1}-${parseInt(selected_day.value)} ${selected_time.value}`;
      const slotTime = moment(date, 'YYYY-MM-DD hh:mm:ss').utc().format();
      this.toggleLoading(true);
      this.props.AdminCreateAppointment(current_time, slotTime, patientSelected.value, counsellorSelected.value);
    }
  }

  componentWillUnmount() {
    this.props.resetCounsellor();
  }

  cancel = () => {
    const { mode } = this.state;
    if (mode === "edit") history.push("/counsellors");
    else history.push("/home");
  };

  render() {
    const {
      whitelabel,
      error_whitelabel,
      counsellor,
      error_counsellor,
      patients,
      error_patient,
      error_date,
      error_time,
      days_created,
      timeZone,
      projectsSelected,
      counsellorSelected,
      patientSelected,
      counsellors_list,
      patients_list,
      mode,
      projects,
      languages,
    } = this.state;

    let optionsProjects = [];
    if (projects && projects.length > 0) {
      projects.map((w) => {
        return optionsProjects.push({ value: w.id, label: w.name });
      });
    }

    let optionsCounsellors = [];
    if (counsellors_list && counsellors_list.length > 0) {
      counsellors_list.map((w) => {
        return optionsCounsellors.push({ value: w.counsellor_details.counsellor_id, label: `${w.user_details.full_name} (${w.user_details.email})` });
      });
    }

    let optionsPatients = [];
    if (patients_list === 'There are no patients available at the moment.') {
      optionsPatients.push({ value: "No options available", label: "No options available" })
    }
    else if (patients_list.length > 0 && patients_list !== 'There are no patients available at the moment.') {
      patients_list.map((w) => {
        return optionsPatients.push({ value: w.patient_details.patient_id, label: `${w.user_details.full_name} (${w.user_details.email})` });
      });
    }

    let optionsLangs = [];
    if (languages && languages.length > 0) {
      languages.map((w) => {
        return optionsLangs.push({ value: w.id, label: w.language });
      });
    }

    if (this.props.loading) return <Loading />;
    else {
      return (
        <div className="ContainerFix">
          <HeaderComponent />
          <Spring
            from={{ transform: "translate(+100%, 0)" }}
            to={{ transform: "translate(0%, 0)" }}
          >
            {(props) => (
              <div className="" style={props}>
                <div className="container-wrap">
                  <div
                    className="row mt-5 mx-auto w-75 pb-5"
                    id="cardButtonContainer"
                  >
                    {/* HEADING CONTAINER STARTS HERE */}
                    <div className="heading-container">
                      <p className="lead heading-line">{constants.APPOINTMENTS}</p>
                      <p className="lead heading-text">
                        {"Create Appointment"}
                        {/* {mode === "edit" */}
                        {/* ? "Update Counsellor" */}
                        {/* : "Create Counsellor"} */}
                      </p>
                      <hr className="lead--heading-line" />
                    </div>
                    {/* HEADING CONTAINER ENDS HERE */}
                    {/* FORM STARTS HERE */}
                    <form name="project-form" className="form-container">
                      {this.props.message && (
                        <div
                          className={`alert text-center alert-danger error-message`}
                          id="errorMessage"
                        >
                          {this.props.message}
                        </div>
                      )}
                      <div className="form-row">
                        <div className="form-group col-md-5 col">
                          <label htmlFor="inputname" className="label-text">
                            {constants.WHITELABEL_TXT}
                            <span className="input-required"> *</span>
                          </label>
                          <Select
                            value={projectsSelected}
                            name="projectsSelected"
                            options={optionsProjects}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.changeProjects}
                          />
                          {error_whitelabel.length > 0 && (
                            <span className="input-required">{error_whitelabel}</span>
                          )}
                        </div>
                        <div className="offset-md-2 form-group col-md-5 col">
                          <label htmlFor="inputname" className="label-text">
                            {constants.COUNSELLOR}
                            <span className="input-required"> *</span>
                          </label>
                          <Select
                            value={counsellorSelected}
                            name="counsellorSelected"
                            options={optionsCounsellors}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.changeCounsellors}
                          />
                          {error_counsellor.length > 0 && (
                            <span className="input-required">{error_counsellor}</span>
                          )}
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-md-5 col">
                          <label htmlFor="inputname" className="label-text">
                            {constants.PATIENTS}
                            <span className="input-required"> *</span>
                          </label>
                          <Select
                            value={patientSelected}
                            name="patientSelected"
                            options={optionsPatients}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.changePatients}
                          />
                          {error_patient.length > 0 && (
                            <span className="input-required">{error_patient}</span>
                          )}
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-md-5">
                          <label htmlFor="inputname" className="label-text">
                            {constants.SELECT_DAY_TXT}
                            <span className="input-required"> *</span>
                          </label>
                          <div className="form-inline">
                            <div className="ap_selector_new">
                              <Select
                                id={"ap_day_selector"}
                                styles={selectStyles}
                                options={days_created}
                                value={this.state.selected_day}
                                onChange={this.onChangeDay}
                                placeholder="Day"
                              />
                            </div>
                            <div className="ap_selector_new">
                              <Select
                                id={"ap_month_selector"}
                                styles={selectStyles}
                                options={optionsMonths}
                                value={this.state.selected_month}
                                onChange={this.onChangeMonth}
                                placeholder="Month"
                              />
                            </div>
                            <div className="ap_selector_new">
                              <Select
                                id={"ap_year_selector"}
                                styles={selectStyles}
                                options={optionsYears}
                                value={this.state.selected_year}
                                onChange={this.onChangeYear}
                                placeholder="Year"
                              />
                            </div>
                          </div>
                          {error_date.length > 0 && (
                            <span className="input-required">{error_date}</span>
                          )}
                        </div>
                        <div className="offset-md-2 form-group col-md-5 col">
                          <label htmlFor="inputname" className="label-text">
                            {constants.SELECT_TIME}
                            <span className="input-required"> *</span>
                          </label>
                          <div className="form-inline">
                            <div className="ap_selector_new">
                              <Select
                                id="ap_time_selector"
                                styles={selectStyles}
                                options={optionsTime}
                                value={this.state.selected_time}
                                onChange={this.onChangeTime}
                                placeholder="Time"
                              />
                            </div>
                            <p className="ap-create-appointment-timezone">{timeZone}</p>
                          </div>
                          {error_time.length > 0 && (
                            <span className="input-required">{error_time}</span>
                          )}
                        </div>
                      </div>
                      <div className="marginTop25 textAlignCenter">
                        <button
                          className="cancel-submit-button"
                          onClick={this.cancel}
                        >
                          {constants.CANCEL_TXT}
                        </button>
                        <button
                          type="button"
                          className="appintment-submit-button"
                          onClick={this.AdminCreateAppointment}
                        >
                          {mode === constants.CREATE_TXT.toLowerCase()
                            ? constants.CREATE_TXT
                            : constants.SAVE_TXT}
                        </button>
                      </div>
                    </form>{" "}
                    {/* FORM ENDS HERE */}
                  </div>
                </div>
              </div>
            )}
          </Spring>
          <Footer />
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  const { alert, languages } = state;
  const authstate = state.auth;
  const { selectedCounsellor, counsellors, loading, message } =
    state.counsellors;
  const { patients } = state.patients;
  const { whitelabel } = state.whitelabel;

  return {
    alert,
    authstate,
    counsellors,
    selectedCounsellor,
    patients,
    whitelabel,
    loading,
    message,
    languages,
  };
}

function mapDispatchToProps(dispatch) {
  // let _id = '6990dd26-7dae-4dff-83ae-122a2d078e6d';
  return {
    saveCounsellor: (obj, id) => {
      dispatch(CounsellorsActions.saveCounsellor(obj, id));
    },
    resetCounsellor: () => {
      dispatch(CounsellorsActions.resetCounsellor());
    },
    fetchCounsellors: () => {
      dispatch(CounsellorsActions.fetchCounsellors());
    },
    AdminCreateAppointment: (current_time, slotTime, patientId, counsellorId) => {
      dispatch(AppointmentActions.AdminCreateAppointment(current_time, slotTime, patientId, counsellorId));
    },
    fetchWhitelabel: () => {
      dispatch(WhitelabelActions.fetchWhitelabel());
    },
    fetchPatients: (id) => {
      dispatch(PatientActions.fetchPatients(id));
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
    alertError: (message) => {
      dispatch(alertActions.error(message));
    },
    fetchLanguages: () => {
      dispatch(LanguagesActions.fetchLanguages());
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateAppointment)
);



// WEBPACK FOOTER //
// ./src/screens/CreateAppointment/index.js